// ===== START: Move Social Proof Section Above Description =====
if (window.location.href.includes('/product')) {
  document.addEventListener('DOMContentLoaded', function() {
    var sp = 0;
    var timersp = setInterval(function() {
      var socialProof = document.querySelector('.social-proof-container');
      var descParent = document.querySelector('.product__description-parent');
      
      if (socialProof && descParent) {
        var socialProofSection = socialProof.closest('[id*="shopify-section"]');
        if (socialProofSection) {
          descParent.parentNode.insertBefore(socialProofSection, descParent);
          clearInterval(timersp);
        }
      }
      
      if (sp > 200) {
        clearInterval(timersp);
      }
      sp++;
    }, 50);
  });
}
// ===== END: Move Social Proof Section Above Description =====


// ===== START: Variant, popup, and FAQ reordering logic =====
setTimeout(function() {
  if (window.location.href.includes('/product')) {
    document.addEventListener('DOMContentLoaded', function() {
      
      // Handle variant change
      var variantLinks = document.querySelector('.variantLinks');
      if (variantLinks) {
        variantLinks.addEventListener('change', function() {
          var checked = document.querySelector('input[name="Knife/Set/Block"]:checked');
          if (checked) {
            window.location = checked.getAttribute('data-attr');
          }
        });
      }

      // Simple shipping popup open
      var shippingBtn = document.getElementById('simple-shipping');
      if (shippingBtn) {
        shippingBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var popup = document.querySelector('.simple-shipping-popup');
          if (popup) popup.classList.add('open');
        });
      }

      // Close popup when clicking close button
      var closeButtons = document.querySelectorAll('span.simple-close');
      closeButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var popup = this.closest('.simple-popup');
          if (popup) popup.classList.remove('open');
        });
      });

      // Prevent popup from closing when clicking inside
      var popups = document.querySelectorAll('.simple-popup');
      popups.forEach(function(popup) {
        popup.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      });

      // Close popup when clicking outside
      window.addEventListener('click', function() {
        var openPopup = document.querySelector('body > .open');
        if (openPopup) {
          var closeBtn = document.querySelector('span.simple-close');
          if (closeBtn) closeBtn.click();
        }
      });

      // Add santoku-knife class if not certain categories
      var collectionTags = document.getElementById('collection-tags');
      if (collectionTags) {
        var tags = collectionTags.getAttribute('collection-tags').toLowerCase();
        if (tags !== 'knife blocks,' && tags !== 'chopping blocks,' && tags !== 'sharpening stones,') {
          document.body.classList.add('santoku-knife');
        }
      }

      // Add 'loaded' class after 1 second
      setTimeout(function() {
        document.body.classList.add('loaded');
      }, 1000);
    });
  }
}, 100);
// ===== END: Variant, popup, and FAQ reordering logic =====


// ===== START: Redirect to cart after Add to Cart =====
if (window.location.href.includes('/product')) {
  document.addEventListener('DOMContentLoaded', function() {
    var atcButton = document.getElementById('custom-atc');
    if (atcButton) {
      atcButton.addEventListener('click', function() {
        document.body.classList.add('conv-redirect');
        var cartBubble = document.querySelector('.cart-count-bubble span');
        var count = cartBubble ? cartBubble.innerHTML : null;
        var x = 0;
        var cTimer = setInterval(function() {
          var newBubble = document.querySelector('.cart-count-bubble span');
          var newCount = newBubble ? newBubble.innerHTML : null;
          if (count !== newCount || x > 200) {
            window.location.href = '/cart';
            clearInterval(cTimer);
          }
          x++;
        }, 50);
      });
    }
  });
}
// ===== END: Redirect to cart after Add to Cart =====


// ===== START: Add trust badges to cart page =====
if (window.location.href.includes('/cart') && !document.querySelector('.simple-badges-outer-container')) {
  document.addEventListener('DOMContentLoaded', function() {
    var footer = document.getElementById('shopify-section-footer');
    if (footer) {
      var badgesHTML = '<div class="simple-badges-outer-container"><div class="simple-img-container"><div class="simple-badges-container"><div class="simple-badge-container"><img src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/public.png?v=1693152558" width="24" height="24" alt="Fast Delivery"><span class="badge0">Fast and Free Delivery</span></div></div><div class="simple-badges-container"><div class="simple-badge-container"><img src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/event_repeat_0f95b70b-b623-496f-86a3-9a701d1de8eb.png?v=1693152558" width="24" height="24" alt="Easy Returns"><span class="badge1">Easy 30 Days Returns</span></div></div><div class="simple-badges-container"><div class="simple-badge-container"><img src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/security_7324a66f-f586-4a7e-beba-0f75fbed89e5.png?v=1693152558" width="24" height="24" alt="Secure Payment"><span class="badge2">100% Secure Payment</span></div></div><div class="simple-badges-container"><div class="simple-badge-container"><img src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/settings_suggest.png?v=1693152558" width="24" height="24" alt="Guarantee"><span class="badge2">Lifetime Manufacturer Guarantee</span></div></div></div></div>';
      footer.insertAdjacentHTML('beforebegin', badgesHTML);
    }
  });
}
// ===== END: Add trust badges to cart page =====


// ===== START: Buy Now Button (Mobile) =====
if (window.location.href.includes('/product')) {
  document.addEventListener('DOMContentLoaded', function() {
    var atcButton = document.getElementById('custom-atc');
    if (atcButton && !document.querySelector('.fh-buyNow')) {
      var buyNowBtn = document.createElement('div');
      buyNowBtn.className = 'fh-buyNow';
      buyNowBtn.textContent = 'Buy Now';
      atcButton.after(buyNowBtn);
      
      buyNowBtn.addEventListener('click', function() {
        var b = 0;
        var timerb = setInterval(function() {
          var moreOptions = document.querySelector('.shopify-payment-button__more-options');
          if (moreOptions || b > 200) {
            if (moreOptions) moreOptions.click();
            clearInterval(timerb);
          }
          b++;
        }, 50);
      });
    }
  });
}
// ===== END: Buy Now Button (Mobile) =====